module.exports = __webpack_public_path__ + "static/media/sc8r_12.9204acc9.png";